
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  source: 'error',
  description: 'Guide to understanding and troubleshooting errors in which the request is valid, but the output would be unusable for any supported flow.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const ErrorReference = makeShortcode("ErrorReference");
const Checkbox = makeShortcode("Checkbox");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Invalid Result errors' subtitle='Guide to troubleshooting invalid result errors' mdxType="Header" />
    <h4 {...{
      "id": "last_updated_datetime_out_of_range"
    }}><strong parentName="h4">{`LAST_UPDATED_DATETIME_OUT_OF_RANGE`}</strong></h4>
    <ErrorReference type='INVALID_RESULT' error='LAST_UPDATED_DATETIME_OUT_OF_RANGE' subtitle="No balance data meeting the requested freshness is available from the Item." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`/accounts/balance/get`}</inlineCode>{` was called with a parameter specifying the minimum acceptable data freshness, but no balance data meeting those requirements was available from the institution.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`This error is not preventable by developer actions. As a workaround, you can use a cached balance from `}<inlineCode parentName="p">{`/accounts/get`}</inlineCode>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    <h4 {...{
      "id": "plaid_direct_item_import_returned_invalid_mfa"
    }}><strong parentName="h4">{`PLAID_DIRECT_ITEM_IMPORT_RETURNED_INVALID_MFA`}</strong></h4>
    <ErrorReference type='INVALID_RESULT' error='PLAID_DIRECT_ITEM_IMPORT_RETURNED_INVALID_MFA' subtitle="The Plaid Direct Item import resulted in invalid MFA." server mdxType="ErrorReference">
      <h5 {...{
        "id": "common-causes-1"
      }}>{`Common causes`}</h5>
      <ul>
        <li parentName="ul">{`No known causes.`}</li>
      </ul>
      <h5 {...{
        "id": "troubleshooting-steps-1"
      }}>{`Troubleshooting steps`}</h5>
      <Checkbox mdxType="Checkbox">
        <p>{`If you experience this error, contact your Plaid account manager or `}<a parentName="p" {...{
            "href": "https://dashboard.plaid.com/support/new/product-and-development/product-troubleshooting/product-functionality"
          }}>{`file a support ticket`}</a>{`.`}</p>
      </Checkbox>
    </ErrorReference>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "last_updated_datetime_out_of_range",
        level: 4,
        title: "LAST_UPDATED_DATETIME_OUT_OF_RANGE",
      },
{
        id: "plaid_direct_item_import_returned_invalid_mfa",
        level: 4,
        title: "PLAID_DIRECT_ITEM_IMPORT_RETURNED_INVALID_MFA",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
